'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var marked = _interopDefault(require('marked'));

function toKebabCase(name) {
  return name.toLowerCase().replace(/ /g, "-");
}
const REGEXP_INTERPOLATE_PARAMS = /\{{1,2}\s*([A-Z\d\-\_\.]+)\s*\}{1,2}/gi;
function interpolate(content, params, isMarkdown = false) {
  let result = content || "";
  result = result.replace(REGEXP_INTERPOLATE_PARAMS, (match, key) => {
    if (params && key in params) {
      return params[key];
    }
    return match;
  });
  if (isMarkdown) {
    result = marked(result);
  }
  return result;
}
function toNumber(value) {
  if (value === null) {
    return 0;
  }
  const parsedNumber = parseInt(value, 10);
  return Number.isNaN(parsedNumber) ? 0 : parsedNumber;
}
function leftPad(n, length = 2, padding = "0") {
  return (n === null ? "" : n).toString().padStart(length, padding);
}
function isTextSelected(value) {
  if (!document.getSelection) {
    return false;
  }
  const selection = document.getSelection();
  if (!selection) {
    return false;
  }
  return value.includes(selection.toString());
}
function slugify(text) {
  if (!text) {
    return "";
  }
  return text.toLowerCase().replace(/[^a-z0-9\u0430-\u044f]+/g, "-").replace(/^-+|-+$/g, "");
}
function truncate(text, limit, truncateWord = true, appendString = "...") {
  if (text.length < limit) {
    return text;
  }
  const result = text.substr(0, limit);
  if (!truncateWord) {
    return `${result}${appendString}`;
  }
  if (result.charAt(limit) === " ") {
    return `${result}${appendString}`;
  }
  return `${result.substr(0, result.lastIndexOf(" "))}${appendString}`;
}

exports.interpolate = interpolate;
exports.isTextSelected = isTextSelected;
exports.leftPad = leftPad;
exports.slugify = slugify;
exports.toKebabCase = toKebabCase;
exports.toNumber = toNumber;
exports.truncate = truncate;
